var map = {
	"./marauders-map-v0-01-01.jpg": 678,
	"./marauders-map-v0-01-02.jpg": 679,
	"./marauders-map-v0-02-01.jpg": 680,
	"./marauders-map-v0-02-02.jpg": 681
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 677;